import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Loader from "atomic-components/Loader";
import { getOverallCreditDetails } from "services/myBuys";

import LedgerEsignPendingSection from "../ledger-esign/LedgerEsignPendingSection";

import HowOldAreYourDues from "./HowOldAreYourDues";
import MyBooksHeader from "./MyBooksHeader";
import NewOutstandingCard from "./NewOutstandingCard";
import OldestUnpaidInvoice from "./OldestUnpaidInvoice";
import { classes } from "./styled";

const MyTransactions = () => {
  const [loading, setLoading] = useState(false);
  const { me } = useSelector((state) => state.app);
  const { myBooksBg } = classes();
  const [creditDetails, setCreditDetails] = useState(null);

  useEffect(() => {
    if (!me || !me.customerId) {
      return;
    }

    const fetchCreditDetails = async () => {
      setLoading(true);
      try {
        const response = await getOverallCreditDetails({
          customer_ids: me.customerId,
        });

        const responseData = response.responseData || response;

        if (responseData?.credit_details) {
          const creditDetailsKeys = Object.keys(responseData.credit_details);
          if (creditDetailsKeys.length > 0) {
            const firstKey = creditDetailsKeys[0];
            const customerData = responseData.credit_details[firstKey];
            setCreditDetails(customerData);
          }
        }
      } catch (error) {
        console.error("Error fetching credit details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCreditDetails();
  }, [me]);

  if (loading) {
    return <Loader />;
  }

  return (
    <div
      className={myBooksBg}
      style={{
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <MyBooksHeader />
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
          padding: "1rem",
          // Clear the fixed bidder bottom tab bar (PaperComponent, ~100-140px incl.
          // the iOS safe-area inset) so the last card isn't hidden under it.
          paddingBottom: "calc(8rem + env(safe-area-inset-bottom, 1.5rem))",
        }}
      >
        <NewOutstandingCard creditDetails={creditDetails} />
        <OldestUnpaidInvoice creditDetails={creditDetails} />
        <HowOldAreYourDues creditDetails={creditDetails} />
        <LedgerEsignPendingSection />
      </div>
    </div>
  );
};

export default MyTransactions;
